import styled from 'shared/utils/styled';

export const UserWarning = styled('span')(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: theme.palette.primary.main,
}));
